<div class="teams-container">
  <div class="teams-header">
    <h2>{{ tabLabel }}</h2>
    @if (loaded && !loadError && model.rows.length) {
      <button mat-stroked-button (click)="exportCsv()">
        <mat-icon>download</mat-icon> Export CSV
      </button>
    }
  </div>

  @if (loaded) {
    @if (loadError) {
      <div class="empty-state">
        Unable to load your team history. Please try again later.
      </div>
    } @else if (model.rows.length && displayedColumns.length) {
      <div class="table-wrapper app-lineup-table">
        <table mat-table [dataSource]="dataSource" matSort class="teams-table">
          @for (col of model.columns; track col.key) {
            <ng-container [matColumnDef]="col.key">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ col.displayName }}
              </th>
              <td mat-cell *matCellDef="let row">
                {{ row.displayValues?.[col.key] }}
              </td>
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    } @else {
      <div class="empty-state">You are not currently part of any teams.</div>
    }
  }
</div>
